import React from 'react';
import LoadingScreen from '../../LoadingScreen';

export default function Loader(): React.JSX.Element {
  return (
    <div className='min-h-72 flex justify-center align-middle'>
      <LoadingScreen />
    </div>
  );
}
